import { enums } from "@shared/constants";
import { PublicInternalAnalyticsTrackingSerializer } from "@shared/modules/analytics/types";
import { IInteractionDataBuilder } from "./IInteractionDataBuilder";

/**
 * Builder for search events.
 */
export class SearchDataBuilder implements IInteractionDataBuilder {
  private data?: Omit<
    PublicInternalAnalyticsTrackingSerializer,
    "interaction_type"
  >;

  constructor(
    data?: Omit<PublicInternalAnalyticsTrackingSerializer, "interaction_type">
  ) {
    this.data = data;
  }

  build(): PublicInternalAnalyticsTrackingSerializer {
    return {
      ...this.data,
      interaction_type: enums.INTERACTION_TYPE_MAP.SEARCH.id,
    };
  }
}
